import * as contentUtils from '../../../utils/content';
import { ResolveFields } from '../../../utils/create-block';
import * as linkUtils from '../../../utils/links';
import * as fieldUtils from '../../../utils/surveys/fields';

import { ICompositeQABlock } from './types';

export const resolveFields: ResolveFields<ICompositeQABlock> = (
  { props: { survey, page, link } },
  { fields, appState }
) => {
  const allLinks = contentUtils.getAllAnchors(appState.data.content);

  return {
    ...fields,
    ...(survey && {
      selectedQuestions: fieldUtils.createQuestionArraySelectField({ survey, page }),
    }),
    detailed: {
      label: 'Detail',
      options: [
        { label: 'Summary', value: 'false' },
        { label: 'Detailed', value: 'true' },
      ],
      type: 'radio',
    },
    title: {
      initialValue: 'Composite QA Block',
      label: 'Title',
      type: 'text',
    },
    truncateTo: {
      initialValue: 0,
      label: 'Truncate answers to n characters',
      type: 'number',
    },
    ...linkUtils.createLinkFields(allLinks, link === linkUtils.EXTERNAL_OPTION_VALUE),
  } as const;
};
